export const timeOut = t => new Promise(resolve => setTimeout(resolve, t));
